/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useEffect } from 'react';

import {
    ButtonVariant,
    transformCurrency,
    transformSubscriptionInterval,
    // transformCurrency,
    // transformSubscriptionInterval,
    useAuthContext,
} from '@catalyze/ui';
import { useManageSubscriptionMutation } from 'api/subscriptions/manageSubscription';
import type {
    ISubscription,
    ISubscriptionInterval,
} from 'api/types/subscription';

import {
    SubscriptionContainer,
    SubscriptionLabel,
    SubscriptionValue,
    SubscriptionButton,
} from './styled';

interface ISubscriptionProps {
    plan: ISubscription | undefined;
}

export const Subscription: FC<ISubscriptionProps> = ({ plan }) => {
    const { user } = useAuthContext();
    const { subscription } = user ?? {};

    const totalSub: string = useMemo(() => {
        let total = 0;
        if (_.isEmpty(subscription)) return '0';

        // @ts-expect-error ttt
        subscription?.forEach((sub: any) => {
            total += sub.quantity * sub.unit_amount;
        });

        return total.toString();
    }, [subscription]);

    const interval: ISubscriptionInterval | undefined = useMemo(() => {
        if (_.isEmpty(subscription)) return undefined;

        return {
            // @ts-expect-error ttt
            unit: subscription[0].recurring.interval,
            // @ts-expect-error ttt
            count: subscription[0].recurring.interval_count,
        };
    }, [subscription]);

    console.log({ totalSub, plan });

    const { mutate: getManageSubscriptionURL, data } =
        useManageSubscriptionMutation({});

    useEffect(() => {
        getManageSubscriptionURL();
    }, [getManageSubscriptionURL]);

    // eslint-disable-next-line @typescript-eslint/require-await
    const handleManageSubsClick = async () => {
        if (!subscription) {
            window.location.href = '/subscription';
        } else {
            // user can cancel plan so we neeed to reset these queries
            window.location.href = data?.redirectUrl || '';
        }
    };
    return (
        <SubscriptionContainer>
            <div>
                <SubscriptionLabel>Plan</SubscriptionLabel>

                {!_.isEmpty(subscription) &&
                    // eslint-disable-next-line no-warning-comments
                    // @ts-expect-error TODO
                    subscription.map((sub: any, i: number) => (
                        <SubscriptionValue bold key={i}>
                            {sub.product.name} ({sub.quantity})
                        </SubscriptionValue>
                    ))}
            </div>
            <div>
                <SubscriptionLabel>Billing information</SubscriptionLabel>
                <SubscriptionValue bold>
                    {!_.isEmpty(subscription) && interval
                        ? `${transformCurrency(
                              totalSub ?? '0'
                          )} - Charged ${transformSubscriptionInterval(
                              interval
                          )}`
                        : '-'}
                </SubscriptionValue>
            </div>
            <SubscriptionButton
                type="button"
                variant={ButtonVariant.PRIMARY}
                onClick={handleManageSubsClick}
            >
                {subscription
                    ? 'Manage subscription'
                    : 'Select your subscription'}
            </SubscriptionButton>
        </SubscriptionContainer>
    );
};
